const Localizacion = ({ width, height, color = '#6A6A6A' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.87351 24.0624C8.18975 22.6262 6.62906 21.0516 5.20775 19.3553C3.07483 16.8078 0.541993 13.0139 0.541993 9.39857C0.541068 7.55221 1.0879 5.74708 2.11328 4.21162C3.13866 2.67616 4.5965 1.47939 6.30229 0.772783C8.00809 0.0661728 9.88517 -0.11852 11.696 0.242078C13.5068 0.602677 15.1699 1.49236 16.4749 2.79852C17.3437 3.6635 18.0324 4.6922 18.501 5.8251C18.9696 6.95799 19.2089 8.17258 19.205 9.39857C19.205 13.0139 16.6722 16.8078 14.5393 19.3553C13.1179 21.0516 11.5573 22.6262 9.87351 24.0624ZM9.87351 5.39935C8.81285 5.39935 7.79563 5.8207 7.04563 6.57069C6.29563 7.32069 5.87429 8.33791 5.87429 9.39857C5.87429 10.4592 6.29563 11.4764 7.04563 12.2264C7.79563 12.9764 8.81285 13.3978 9.87351 13.3978C10.9342 13.3978 11.9514 12.9764 12.7014 12.2264C13.4514 11.4764 13.8727 10.4592 13.8727 9.39857C13.8727 8.33791 13.4514 7.32069 12.7014 6.57069C11.9514 5.8207 10.9342 5.39935 9.87351 5.39935Z"
        fill={color}
      />
    </svg>
  );
};
export default Localizacion;
